'use client';

import UserIcon from '@/assets/icons/User';
import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/ui/cn';
import { useMsal } from '@azure/msal-react';
import { useContext } from 'react';
import { AuthContext } from '../auth/AuthProvider';

interface MemberNavigationProps {
  onLogout?: () => void;
}

interface MemberNavigationActionsProps {
  onLogout?: () => void;
  onNavigate?: () => void;
  className?: string;
  memberButtonClassName?: string;
  logoutButtonClassName?: string;
}

export function MemberNavigationActions({
  onLogout,
  onNavigate,
  className,
  memberButtonClassName,
  logoutButtonClassName,
}: MemberNavigationActionsProps) {
  const { state: authState } = useContext(AuthContext);
  const { accounts } = useMsal();
  const userName = accounts[0]?.name?.split(' ')[0] ?? authState.firstName;

  function handleLogout() {
    onNavigate?.();
    onLogout?.();
  }

  return (
    <div className={cn('flex items-center justify-center gap-1', className)}>
      <Button
        asChild
        variant='ghost'
        className={cn(
          'w-auto cursor-auto gap-2 hover:bg-transparent',
          memberButtonClassName
        )}
        size='small'
      >
        <div>
          <UserIcon className='size-5' />
          <span>{userName}</span>
        </div>
      </Button>

      {onLogout && (
        <Button
          variant='ghost'
          aria-label='Log out'
          className={cn('w-auto', logoutButtonClassName)}
          size='small'
          onClick={handleLogout}
        >
          Log out
        </Button>
      )}
    </div>
  );
}

export default function MemberNavigation({ onLogout }: MemberNavigationProps) {
  return (
    <div
      data-test='member-navbar'
      className='border-b-sh-gray/42 bg-sh-paper/85 hidden border-b backdrop-blur md:block'
    >
      <div className='px-5 py-2 md:px-22.5'>
        <MemberNavigationActions
          onLogout={onLogout}
          className='justify-center lg:justify-end'
        />
      </div>
    </div>
  );
}
